import {createLazyFileRoute} from '@tanstack/react-router'

import ResetPassword from '@/views/auth/ResetPassword/ResetPassword'

export const Route = createLazyFileRoute('/auth/reset-password')({
  component: ResetPassword,
})
